var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"text-center"},[_c('router-link',{attrs:{"to":"/home"}},[_c('Logo')],1),_c('div',[_vm._v(_vm._s(_vm.$t("title.membersOnlySiteLogin")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }